import React, { Fragment } from "react";
import { translate } from "../Services/translation";

import Svg from "./Svg";

const Navigation = ({ links =[], contentLink = null, level = 0 }) => {
	let menuRef = React.createRef();
	function toggleMenu() {
		menuRef.current.classList.toggle("navbar__menu--show");
	}
	const additionClass =
		contentLink && contentLink.attributes
			? contentLink.attributes.cssValue
			: null;
	const hasChildrenClass = links.length > 0 ? "has-children" : null;
	const hasUrlClass = contentLink && contentLink.url ? "" : "no-url";
	const menuMobileTopValueClass = !contentLink
		? "navbar__menu--top-header-height"
		: null;

	const NavbarLink = () => {
		if (hasUrlClass !== "no-url") {
			return (
				<a
					className={`navbar__link ${hasChildrenClass || ""} ${additionClass || ""}`}
					href={contentLink.url || "#"}
					dangerouslySetInnerHTML={{ __html: contentLink.name }}
					onKeyDown={onKeyDown}
					data-level={level}
				/>
			);
		}
		return (
			<div
				className={`navbar__link ${hasChildrenClass || ""} ${additionClass || ""} ${hasUrlClass}`}
				dangerouslySetInnerHTML={{ __html: contentLink.name }}
				onKeyDown={onKeyDown}
			/>
		);
	};

	const onKeyDown = (e) => {
		if (level !== 1) return;

		switch (e.keyCode) {
			case 40: 
				e.preventDefault();
				e.target.parentElement.classList.add("navbar__item--active");
				break;
			case 38: 
				e.preventDefault();
				e.target.parentElement.classList.remove("navbar__item--active");
				break;
			default:
				break;
		}
	};

	const handleBlur = (e) => {
		if (!menuRef.current || level !== 1) return;
		if (!menuRef.current.contains(e.relatedTarget)) {
			const activeItems = document.querySelectorAll('.navbar__item--active');
			activeItems.forEach(item => item.classList.remove("navbar__item--active"));
		}
	};

	const handleMouseLeave = (e) => {
		if (!menuRef.current) return;
		const activeItems = document.querySelectorAll('.navbar__item--active');
		activeItems.forEach(item => item.classList.remove("navbar__item--active"));
	};

	return (
		<Fragment>
			{!contentLink ? 
				<a
					className="navbar__link--block navbar__icon--menu navbar__icon"
					onClick={toggleMenu}
				/>
			 : 
				<Fragment>
					<NavbarLink />
					{links.length > 0 && (
						<i
							className="navbar__icon navbar__icon--open"
							onClick={toggleMenu}
						>
							<Svg icon="arrow-right"/>
						</i>
					)}
				</Fragment>
			}

			{links.length > 0 && 
				<ul
					className={`navbar__menu ${menuMobileTopValueClass || ""}`}
					ref={menuRef}
					test={links.length}
					onBlur={handleBlur}
					onMouseLeave={handleMouseLeave}
				>
					<div className="navbar__menu-header">
						{contentLink && (
							<Fragment>
								<i
									className="navbar__icon"
									onClick={toggleMenu}
								>
									<Svg icon="arrow-left"/>
								</i>
								<span
									className="navbar__title"
									onClick={toggleMenu}
									dangerouslySetInnerHTML={{ __html: contentLink.name }}
								/>
							</Fragment>
						)}
					</div>
					{links.length > 0 &&
						links.map((link, i) =>
							!link.name ? null : (
								<li className="navbar__item" key={`${link.name}-${i}`}>
									<Navigation links={link.links} contentLink={link} level={level + 1} />
									{link.attributes && link.attributes.includeSeeAll && (
										<div className="navbar__item-see-all">
											<a href={link.url} className="navbar__item-see-all--link">
												{translate("columbus.seeAll")}
											</a>
										</div>
									)}

									{!contentLink && (
										<div className="magic-line-container">
											<div className="magic-line" />
										</div>
									)}
								</li>
							)
						)}

					{contentLink && contentLink.recommendationCategoryLink && (
						<div className="navbar__recommendation">
							<div className="navbar__recommendation-inner">
								<a href="#" className="navbar__link navbar__link-title">
									{contentLink.recommendationCategoryLink.recommendationTitle}
								</a>
								<a href={contentLink.recommendationCategoryLink.url}>
									<img
										src={
											contentLink.recommendationCategoryLink
												.recommendationImageUrl
										}
										alt="recommendation category"
									/>
									<p className="navbar__recommendation-highlight-text">
										{contentLink.recommendationCategoryLink.name}
										<Svg icon="arrow-right-circle" />
									</p>
								</a>
							</div>
						</div>
					)}
				</ul>
			}
		</Fragment>
	);
};

export default Navigation;
